 
  $(document).ready(function(){
    
    jQuery("#testimonial-carousel").owlCarousel({
        autoplay: false,
        lazyLoad: true,
        loop: true,
        margin: 20,
        responsiveClass: true,
        autoHeight: true,
        autoplayTimeout: 7000,
        smartSpeed: 800,
        nav: true,
      	navText: ['<img src="https://cdn.shopify.com/s/files/1/0526/4261/1377/files/left-arrow.png">','<img src="https://cdn.shopify.com/s/files/1/0526/4261/1377/files/right-arrow.png">'],
        items: 1
      });
    
    
    jQuery("#teencollec-carousel").owlCarousel({
      autoplay: false,
      lazyLoad: true,
      loop: true,
      margin: 20,
      responsiveClass: true,
      autoHeight: true,
      autoplayTimeout: 7000,
      smartSpeed: 800,
      nav: true,
      navText: ['<img src="https://cdn.shopify.com/s/files/1/0526/4261/1377/files/white-left-arrow.png">','<img src="https://cdn.shopify.com/s/files/1/0526/4261/1377/files/white-right-arrow.png">'],
      responsive: {
        0: {
          items: 1
        },

        600: {
          items: 3
        },

        1024: {
          items: 3
        },

        1366: {
          items: 3
        }
      }
    });
    
    
    jQuery("#trending-carousel").owlCarousel({
      autoplay: false,
      lazyLoad: true,
      loop: true,
      margin: 20,
      responsiveClass: true,
      autoHeight: true,
      autoplayTimeout: 7000,
      smartSpeed: 800,
      nav: true,
      navText: ['<img src="https://cdn.shopify.com/s/files/1/0526/4261/1377/files/left-arrow.png">','<img src="https://cdn.shopify.com/s/files/1/0526/4261/1377/files/right-arrow.png">'],
      responsive: {
        0: {
          items: 1
        },

        600: {
          items: 3
        },

        1024: {
          items: 3
        },

        1366: {
          items: 3
        }
      }
    });
    
    
    jQuery("#teencor-carousel").owlCarousel({
      autoplay: false,
      lazyLoad: true,
      loop: true,
      margin: 20,
      responsiveClass: true,
      autoHeight: true,
      autoplayTimeout: 7000,
      smartSpeed: 800,
      nav: true,
      navText: ['<img src="https://cdn.shopify.com/s/files/1/0526/4261/1377/files/white-left-arrow.png">','<img src="https://cdn.shopify.com/s/files/1/0526/4261/1377/files/white-right-arrow.png">'],
      responsive: {
        0: {
          items: 1
        },

        600: {
          items: 3
        },

        1024: {
          items: 3
        },

        1366: {
          items: 3
        }
      }
    });
    
    
    jQuery(".bodyboardsec a").click(function() {
      jQuery('html, body').animate({
        scrollTop: jQuery(".abtestimonialsec").offset().top
      }, 2000);
    });
    
    jQuery(".meetus a").click(function() {
      jQuery('html, body').animate({
        scrollTop: jQuery(".abbgbxsec").offset().top
      }, 2000);
    });
    
    
    /*var elements = jQuery('.modal-overlay, .modal');

    jQuery('.socialimplactpop a').click(function(){
        elements.addClass('active');
    });

    jQuery('.close-modal').click(function(){
        elements.removeClass('active');
    });
    
    
    var elements1 = jQuery('.modal-overlay1, .modal1');

    jQuery('.podcastpop a').click(function(){
        elements1.addClass('active');
    });

    jQuery('.close-modal').click(function(){
        elements1.removeClass('active');
    });
    
    
    var elements3 = jQuery('.modal-overlay2, .modal2');

    jQuery('.podcastpop1').click(function(){
      elements3.addClass('active');
    });

    jQuery('.close-modal').click(function(){
      elements3.removeClass('active');
    });
    
    
    var elements4 = jQuery('.modal-overlay3, .modal3');

    jQuery('.ybqpop').click(function(){
      elements4.addClass('active');
    });

    jQuery('.close-modal').click(function(){
      elements4.removeClass('active');
    });
    */
    
    
   /*var elements5 = jQuery('.modal-overlay5, .modal5');

    jQuery('.joinlist').click(function(){
      elements5.addClass('active');
    });

    jQuery('.close-modal').click(function(){
      elements5.removeClass('active');
    });*/

    
    

  });
  